import TimetableIcon from './component'

export default TimetableIcon
